import React, { createContext, useContext, useState } from 'react';

const GradientContext = createContext();

export const useGradient = () => {
  return useContext(GradientContext);
};

export const GradientProvider = ({ children }) => {
  const [selectedGradient, setSelectedGradient] = useState('linear-gradient(45deg, #F0EADB, #FFFFFF)'); // Default gradient (null means no gradient)

  const setGradient = (gradient) => {
    setSelectedGradient(gradient);
  };

  return (
    <GradientContext.Provider value={{ selectedGradient, setGradient }}>
      {children}
    </GradientContext.Provider>
  );
};
